import classNames from 'classnames'
import { observer } from 'mobx-react'
import styles from './VipBadge.module.less'

export const VipBadge = observer(({ version }: { version: 'pro' | 'max' | 'ultra' }) => {
  const versionNameMap = {
    pro: 'Pro',
    max: 'Max',
    ultra: 'Ultra',
  }
  return (
    <div className={classNames(styles.vipBadge, styles[version])}>{versionNameMap[version]}</div>
  )
})
